import script from "./Menu.vue?vue&type=script&lang=ts&setup=true"
export * from "./Menu.vue?vue&type=script&lang=ts&setup=true"

import "./Menu.vue?vue&type=style&index=0&id=e58eecea&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2780876773/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e58eecea"]])

export default __exports__